import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';
import './AuthForms.css';

const Login = ({ login }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { email, password } = formData;

  const onChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async e => {
    e.preventDefault();
    
    // Validate inputs
    if (!email || !password) {
      setError('Please enter all fields');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      const res = await api.post('/api/login', formData);
      
      // Call login function from App.js
      login(res.data.user, res.data.token);
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred during login');
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <Link to="/" className="back-to-home">← Back to Home</Link>
      
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>SafeHer</h1>
            <h2>Welcome Back</h2>
            <p>Login to continue keeping our community safe</p>
          </div>

          {error && <div className="auth-error">{error}</div>}
          
          <form onSubmit={onSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={onChange}
                placeholder="your@email.com"
                required
              />
            </div>
            
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                value={password}
                onChange={onChange}
                placeholder="Enter your password"
                required
              />
            </div>
            
            <button type="submit" className="auth-button" disabled={loading}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
          
          <div className="auth-footer">
            <p>Don't have an account? <Link to="/register">Sign up here</Link></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
